// src/HandbookEditor.js

import React, { useEffect, useState } from "react";
import "./HandbookEditor.css";

const EN_URL = "https://ietkd-study.web.app/questions-en.json";
const ES_URL = "https://ietkd-study.web.app/questions-es.json";

export default function HandbookEditor() {

  const [englishQuestions, setEnglishQuestions] = useState([]);
  const [spanishQuestions, setSpanishQuestions] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    loadQuestions();
  }, []);


  const loadQuestions = async () => {

    try {

      const [enResponse, esResponse] = await Promise.all([
        fetch(EN_URL),
        fetch(ES_URL)
      ]);

      const enData = await enResponse.json();
      const esData = await esResponse.json();

    const savedEN = localStorage.getItem("tkdstudy-editor-en");
    const savedES = localStorage.getItem("tkdstudy-editor-es");

    if (savedEN && savedES) {
        setEnglishQuestions(JSON.parse(savedEN));
        setSpanishQuestions(JSON.parse(savedES));
    } else {
        setEnglishQuestions(enData);
        setSpanishQuestions(esData);
    }

    } catch(error) {

      console.error(error);

    } finally {

      setLoading(false);

    }

  };


const updateField = (language, index, field, value) => {


    if(language === "en") {

      const updatedEN = [...englishQuestions];

      updatedEN[index][field] = value;

      setEnglishQuestions(updatedEN);


      if(
        field === "kup" ||
        field === "category" ||
        field === "enabled"
      ) {

        const updatedES = [...spanishQuestions];

        updatedES[index][field] = value;

        setSpanishQuestions(updatedES);

      }

    }



    if(language === "es") {

      const updatedES = [...spanishQuestions];

      updatedES[index][field] = value;

      setSpanishQuestions(updatedES);


      if(
        field === "kup" ||
        field === "category" ||
        field === "enabled"
      ) {

        const updatedEN = [...englishQuestions];

        updatedEN[index][field] = value;

        setEnglishQuestions(updatedEN);

      }

    }

  };


  const updateIncorrect = (language, index, answerIndex, value) => {

    if(language === "en") {

      const updated = [...englishQuestions];

      updated[index].incorrect[answerIndex] = value;

      setEnglishQuestions(updated);

    }


    if(language === "es") {

      const updated = [...spanishQuestions];

      updated[index].incorrect[answerIndex] = value;

      setSpanishQuestions(updated);

    }

  };

    const addQuestion = () => {

    const nextId =
    "q" +
    (
      Math.max(
        ...englishQuestions.map(q => Number(q.id.replace("q", "")))
      ) + 1
    );

    const newEnglish = {
      id: nextId,
      kup: 9,
      category: "general",
      enabled: true,
      question: "New question",
      correct: "Correct answer",
      incorrect: [
        "Incorrect answer 1",
        "Incorrect answer 2",
        "Incorrect answer 3"
      ]
    };


    const newSpanish = {
      id: nextId,
      kup: 9,
      category: "general",
      enabled: true,
      question: "Nueva pregunta",
      correct: "Respuesta correcta",
      incorrect: [
        "Respuesta incorrecta 1",
        "Respuesta incorrecta 2",
        "Respuesta incorrecta 3"
      ]
    };

    setEnglishQuestions([
      ...englishQuestions,
      newEnglish
    ]);

    setSpanishQuestions([
      ...spanishQuestions,
      newSpanish
    ]);


    setExpanded(englishQuestions.length);

  };


    const addIncorrect = (language, index) => {

    if(language === "en") {

      const updated = [...englishQuestions];

      updated[index].incorrect.push("New incorrect answer");

      setEnglishQuestions(updated);

    }


    if(language === "es") {

      const updated = [...spanishQuestions];

      updated[index].incorrect.push("Nueva respuesta incorrecta");

      setSpanishQuestions(updated);

    }

  };

  const deleteIncorrect = (language, index, answerIndex) => {

    if (language === "en") {

      const updated = [...englishQuestions];

      if (updated[index].incorrect.length <= 3) {
        alert("A question must have at least 3 incorrect answers.");
        return;
      }

      updated[index].incorrect.splice(answerIndex, 1);

      setEnglishQuestions(updated);

    }


    if (language === "es") {

      const updated = [...spanishQuestions];

      if (updated[index].incorrect.length <= 3) {
        alert("A question must have at least 3 incorrect answers.");
        return;
      }

      updated[index].incorrect.splice(answerIndex, 1);

      setSpanishQuestions(updated);

    }

  };

  const deleteQuestion = (index) => {

    const questionId = englishQuestions[index].id;

    if (!window.confirm(`Delete ${questionId}?\n\nThis cannot be undone.`)) {
      return;
    }

    const updatedEN = englishQuestions.filter((_, i) => i !== index);
    const updatedES = spanishQuestions.filter((_, i) => i !== index);

    setEnglishQuestions(updatedEN);
    setSpanishQuestions(updatedES);

    setExpanded(null);

  };

  const saveProgress = () => {

    localStorage.setItem(
      "tkdstudy-editor-en",
      JSON.stringify(englishQuestions)
    );

    localStorage.setItem(
      "tkdstudy-editor-es",
      JSON.stringify(syncEnabledState())
    );

    alert("Progress saved.");

  };

  const reloadFromServer = () => {

    if (!window.confirm("Discard all unsaved changes and reload from the website?")) {
        return;
    }

    localStorage.removeItem("tkdstudy-editor-en");
    localStorage.removeItem("tkdstudy-editor-es");

    setExpanded(null);

    loadQuestions();

  };

  const syncEnabledState = () => {

    const updatedSpanish = spanishQuestions.map((question, index) => {

      return {
        ...question,
        kup: englishQuestions[index]?.kup,
        category: englishQuestions[index]?.category,
        enabled: englishQuestions[index]?.enabled
      };

    });

    return updatedSpanish;

  };

  const exportJSON = (data, filename) => {

    const blob = new Blob(
      [
        JSON.stringify(data, null, 4)
      ],
      {
        type: "application/json"
      }
    );


    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = filename;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);

  };

  if(loading) {
    return <p>Loading questions...</p>;
  }


  return (

    <div className="json-editor">

      <h1>TKD Study JSON Editor</h1>

      {englishQuestions.map((enQuestion, index)=>{

        const esQuestion = spanishQuestions[index];

        const isOpen = expanded === index;


        return (

          <div className="question-container" key={enQuestion.id}>


            <div className="question-summary">


              <div>

                <strong>{enQuestion.id}</strong>

                <span>
                  Kup {enQuestion.kup}
                </span>

                <span>
                  {enQuestion.category}
                </span>

                <span>
                  {enQuestion.enabled ? "Enabled" : "Disabled"}
                </span>

              </div>


              <div className="preview">

                🇬🇧 {enQuestion.question}

                <br/>

                🇪🇸 {esQuestion?.question}

              </div>


              <button
                onClick={() =>
                  setExpanded(isOpen ? null : index)
                }
              >

                {isOpen ? "Close" : "Edit"}

              </button>


            </div>



            {isOpen && (

              <div className="edit-area">


                <h2>{enQuestion.id}</h2>

                <button
                  className="delete-question"
                  onClick={() => deleteQuestion(index)}
                >
                  Delete Question
                </button>


                <label>
                  Kup
                </label>

                <input
                  type="number"
                  value={enQuestion.kup}
                  onChange={(e)=>
                    updateField(
                      "en",
                      index,
                      "kup",
                      Number(e.target.value)
                    )
                  }
                />


                <label>
                  Category
                </label>

                <input
                  value={enQuestion.category}
                  onChange={(e)=>
                    updateField(
                      "en",
                      index,
                      "category",
                      e.target.value
                    )
                  }
                />


                <label>
                  Enabled
                </label>

                <input
                  type="checkbox"
                  checked={enQuestion.enabled}
                  onChange={(e)=>
                    updateField(
                      "en",
                      index,
                      "enabled",
                      e.target.checked
                    )
                  }
                />



                <div className="language-edit">


                  <div>

                    <h3>🇬🇧 English</h3>

                    <textarea
                      value={enQuestion.question}
                      onChange={(e)=>
                        updateField(
                          "en",
                          index,
                          "question",
                          e.target.value
                        )
                      }
                    />


                    <textarea
                      value={enQuestion.correct}
                      onChange={(e)=>
                        updateField(
                          "en",
                          index,
                          "correct",
                          e.target.value
                        )
                      }
                    />

                    {enQuestion.incorrect.map((a, i) => (

                      <div className="incorrect-row" key={i}>

                        <input
                          value={a}
                          onChange={(e) =>
                            updateIncorrect(
                              "en",
                              index,
                              i,
                              e.target.value
                            )
                          }
                        />

                        <button
                          className="delete-answer"
                          onClick={() =>
                            deleteIncorrect(
                              "en",
                              index,
                              i
                            )
                          }
                        >
                          ✕
                        </button>

                      </div>

                    ))}

                    <button
                      onClick={() =>
                        addIncorrect("en", index)
                      }
                    >
                      + Add Incorrect Answer
                    </button>

                  </div>

                  <div>

                    <h3>🇪🇸 Spanish</h3>


                    <textarea
                      value={esQuestion.question}
                      onChange={(e)=>
                        updateField(
                          "es",
                          index,
                          "question",
                          e.target.value
                        )
                      }
                    />


                    <textarea
                      value={esQuestion.correct}
                      onChange={(e)=>
                        updateField(
                          "es",
                          index,
                          "correct",
                          e.target.value
                        )
                      }
                    />

                    {esQuestion.incorrect.map((a, i) => (

                      <div className="incorrect-row" key={i}>

                        <input
                          value={a}
                          onChange={(e) =>
                            updateIncorrect(
                              "es",
                              index,
                              i,
                              e.target.value
                            )
                          }
                        />

                        <button
                          className="delete-answer"
                          onClick={() =>
                            deleteIncorrect(
                              "es",
                              index,
                              i
                            )
                          }
                        >
                          ✕
                        </button>

                      </div>

                    ))}

                    <button
                      onClick={() =>
                        addIncorrect("es", index)
                      }
                    >
                      + Add Incorrect Answer
                    </button>


                  </div>


                </div>


              </div>

            )}


          </div>

        );

      })}

      <div className="toolbar">

          <button onClick={addQuestion}>
            + Add Question
          </button>


          <button
            onClick={() =>
              exportJSON(
                englishQuestions,
                "questions-en.json"
              )
            }
          >
            Export English JSON
          </button>


          <button
            onClick={() =>
              exportJSON(
                syncEnabledState(),
                "questions-es.json"
              )
            }
          >
            Export Spanish JSON
          </button>

          <button onClick={saveProgress}>
              Save Progress
          </button>

          <button onClick={reloadFromServer}>
              Reload
          </button>

        </div>


    </div>

  );

}